import { API_BASE_URL } from '../config/api';

export const TIMEZONE_OFFSET_HEADER = 'timezone-offset';

export const getTimezoneOffsetHeaderValue = () => String(-new Date().getTimezoneOffset());

export const withTimezoneOffsetHeader = (options = {}) => {
  const headers = new Headers(options.headers || {});
  if (!headers.has(TIMEZONE_OFFSET_HEADER)) {
    headers.set(TIMEZONE_OFFSET_HEADER, getTimezoneOffsetHeaderValue());
  }
  return { ...options, headers };
};

export const installTimezoneOffsetFetch = () => {
  if (typeof window === 'undefined' || !window.fetch || window.__realAirTimezoneOffsetFetchInstalled) {
    return;
  }

  const originalFetch = window.fetch.bind(window);

  window.fetch = (input, options = {}) => {
    const requestUrl = typeof input === 'string' ? input : input?.url;
    const isApiRequest = !requestUrl || requestUrl.startsWith('/') || requestUrl.startsWith(API_BASE_URL);
    if (!isApiRequest) {
      return originalFetch(input, options);
    }
    const requestHeaders = typeof Request !== 'undefined' && input instanceof Request ? input.headers : undefined;
    const headers = new Headers(requestHeaders || {});

    if (options.headers) {
      new Headers(options.headers).forEach((value, key) => headers.set(key, value));
    }

    if (!headers.has(TIMEZONE_OFFSET_HEADER)) {
      headers.set(TIMEZONE_OFFSET_HEADER, getTimezoneOffsetHeaderValue());
    }

    return originalFetch(input, { ...options, headers });
  };

  window.__realAirTimezoneOffsetFetchInstalled = true;
};